export default __webpack_public_path__ + "81bc66452b260566033016222a59d3ea.png";